// @ts-nocheck
import { GridItemProps } from "@insite/mobius/GridItem";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import { statusStyles } from "@store/Themes/common/mixins/status";
import { checkoutOrderTotalItemStyles, commonGridItemStyles } from "@store/Themes/common/mixins/checkout";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export interface StoreCheckoutGridProps {
    container?: GridContainerProps;
    mainColumn?: GridItemProps;
    sideColumn?: GridItemProps;
}

export const checkoutGridProps: StoreCheckoutGridProps = {
    container: {
        gap: 32,
    },
    mainColumn: {
        width: [12, 12, 8, 8, 8],
        printWidth: 12,
    },
    sideColumn: {
        width: [12, 12, 4, 4, 4],
        printWidth: 12,
    },
};

// ORDER TOTAL
export interface StoreOrderTotalStyles {
    wrapper?: InjectableCss;
    container?: GridContainerProps;
    labelGridItem?: GridItemProps;
    valueGridItem?: GridItemProps;
    title?: TypographyProps;
    titleGridItem?: GridItemProps;
    value?: TypographyProps;
    totalLabel?: TypographyProps;
    totalLabelNote?: TypographyProps;
    totalValue?: TypographyProps;
    subtitle?: TypographyProps;
    loadingSpinner?: LoadingSpinnerProps;
    grandTotalLabelGridItem: GridItemProps;
    grandTotalValueGridItem: GridItemProps;
    wrapperTotalText?: InjectableCss;
    approverReasonGridItem?: GridItemProps;
    disclaimerGridItem?: GridItemProps;
    priceDisclaimerValue?: TypographyProps;
}

const paddingGrandTotal = 20;

const orderTotalValueStyles = () => {
    return css`
        margin-left: auto;
    `;
};

const orderTotalTextStyles = () => {
    return css`
        color: ${getColor("primary.light")};
        font-size: ${x => x.theme.design.typography.size.large};
        font-weight: ${x => x.theme.design.typography.weight.medium};
    `;
};

export const orderTotalProps: StoreOrderTotalStyles = {
    wrapper: {
        css: css`
            background-color: ${getColor("common.accent")};
            padding: ${pxToRem(20)};
        `,
    },
    container: {
        gap: 0,
        css: css`
            margin-bottom: ${pxToRem(20)};
        `,
    },
    title: {
        as: "h2",
        css: css`
            font-size: ${x => x.theme.design.typography.size.large};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            color: ${getColor("primary")};
        `,
    },
    titleGridItem: {
        width: 12,
        css: css`
            padding: 0 0 1em;
            &:last-child {
                padding-bottom: 0;
            }
        `,
    },
    labelGridItem: {
        width: 6,
        css: css`
            ${checkoutOrderTotalItemStyles(2)}
            flex-direction: column;
        `,
    },
    valueGridItem: {
        width: 6,
        css: css`
            ${checkoutOrderTotalItemStyles(1)}
            align-items: flex-end;

            @media print {
                text-align: right;
            }
        `,
    },
    value: {
        css: css`
            ${orderTotalValueStyles()}
        `,
    },
    grandTotalLabelGridItem: {
        width: 6,
        css: css`
            ${checkoutOrderTotalItemStyles(2, paddingGrandTotal)}
            flex-direction: column;
        `,
    },
    grandTotalValueGridItem: {
        width: 6,
        css: css`
            ${checkoutOrderTotalItemStyles(1, paddingGrandTotal)}
            align-items: flex-end;

            @media print {
                text-align: right;
            }
        `,
    },
    wrapperTotalText: {
        css: css`
            display: flex;
            align-items: center;
            flex-wrap: wrap;
        `,
    },
    totalLabel: {
        css: css`
            ${orderTotalTextStyles()}
        `,
    },
    totalLabelNote: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smaller};
            font-style: italic;
        `,
    },
    totalValue: {
        css: css`
            ${orderTotalTextStyles()}
            ${orderTotalValueStyles()}
        `,
    },
    subtitle: {
        italic: true,
        css: css`
            margin-top: 0.25em;
        `,
    },
    loadingSpinner: {
        size: 15,
        css: css`
            margin-top: auto;
            margin-bottom: auto;
            margin-left: auto;
        `,
    },
    approverReasonGridItem: {
        width: 12,
        css: css`
            justify-content: center;
        `,
    },
    disclaimerGridItem: {
        width: 12,
        css: css`
            justify-content: center;
            flex-direction: column;
            padding-top: ${pxToRem(20)};

            ${TypographyStyle} {
                margin-bottom: ${pxToRem(20)};

                &:last-child {
                    margin-bottom: 0;
                }
            }
        `,
    },
    priceDisclaimerValue: {
        css: css`
            ${statusStyles("info")}
            width: 100%;
            font-style: italic;
        `,
    },
};

export const orderNumberHeading: TypographyProps = {
    variant: "h2",
    css: css`
        &&&&&& {
            width: 100%;
        }
    `,
};

export const orderDataLabel: TypographyProps = {
    variant: "h5",
    as: "h2",
    css: css`
        @media print {
            font-size: 12px;
        }
    `,
};

export const orderDataValue: TypographyProps = {
    as: "div",
    css: css`
        @media print {
            font-size: 12px;
        }
    `,
};
